// extracted by mini-css-extract-plugin
export default {"component":"DirSearch_component__koDaN","button":"DirSearch_button__a236G"};